<template>
    <div>

        <div class="form-group">
            <label for="property_type" class="required">{{ $t('parameters.form.names.building_type') }}</label>
            <div class="custom-radio-lg custom-radio-lg--inline">
                <div v-for="(propertyType, index) in propertyTypes"
                     class="custom-control custom-radio custom-checkbox-lg__item"
                >

                    <input type="radio" :id="'property_type-' + propertyType.id" name="property_type"
                           v-model="propertyTypeModel"
                           :value="'property_type-' + propertyType.id"
                           class="custom-control-input"
                           :checked="'property_type-' + propertyType.id === 'property_type-' + oldProperty"
                           required
                    >
                    <label class="custom-control-label"
                           :for="'property_type-' + propertyType.id">{{ $t('property_type.' + propertyType.id) }}</label>
                </div>
                <div class="custom-control custom-radio custom-checkbox-lg__item"
                >
                    <input type="radio" name="property_type" id="flat"
                           class="custom-control-input" disabled

                    >
                    <label class="custom-control-label disabled"
                           for="flat"
                           data-toggle="modal"
                           data-target="#flatModalInfo"
                    >
                        {{ $t('property_type.flat') }}
                    </label>
                </div>
            </div>


            <div class="modal fade" id="flatModalInfo" tabindex="-1" aria-labelledby="flatModalInfoLabel"
                 aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="flatModalInfoLabel">{{ $t('reproduction.flat_price') }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            {{ $t('disposition.help.flat_reproduction_price') }}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $t('buttons.close') }}</button>
                            <a :href="modalUrl" class="btn btn-primary">{{ $t('reproduction.find_price') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Podkategorie -->
        <reproduction-subtype
            :propertyTypeModel="propertyTypeModel"
            :old-sub-type="oldHouse"
            @update:value="(value) => houseType = value"
        ></reproduction-subtype>

        <reproduction-construction
            :propertyTypeModel="propertyTypeModel"
            :houseType="houseType"
            :old-construction="oldConstruction"
        ></reproduction-construction>

        <reproduction-quality :propertyTypeModel="propertyTypeModel" :old-quality="oldQuality"></reproduction-quality>

    </div>

</template>

<script>
export default {
    name: 'ReproductionPriceForm',
    props: ['oldProperty', 'oldHouse', 'oldConstruction', 'oldQuality', 'modalUrl'],
    data() {
        return {
            propertyTypeModel: 'property_type-family_house',
            propertyTypes: [
                {
                    id: 'family_house',
                    name: 'Rodinný dům',
                },
                {
                    id: 'recreational',
                    name: 'Rekreační objekt',
                },
                {
                    id: 'apartment_house',
                    name: 'Bytový dům',
                },
            ],
            houseType: null
        }
    },
    created() {
        this.houseType = 'house_type-' + (this.oldHouse !== '' ? this.oldHouse : 'individual');
    },
    mounted() {
        if (this.oldProperty !== '') {
            this.propertyTypeModel = 'property_type-' + this.oldProperty
        }
    }
}
</script>
